var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PanleWrap',[_c('div',{staticClass:"list_header"},[_c('h3',{staticClass:"title"},[_vm._v("重点关注门店")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }